<template>
  <div>
    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on }">
        <v-btn class="extra-small" color="primary" fab outline v-on="on">
          <span class="fas fa-ellipsis-v"></span>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile v-for="(item, index) in items" :key="index" @click="insertPrefill(item.value)">
          <v-list-tile-title class="primary-color">{{ item.title }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click="openDialog('zwiz')"
          v-if="!isWelcome && !isCommentToInbox && $store.getters.getPackage === 'premium'"
        >
          <v-list-tile-title class="primary-color">{{ $t('auto_verify_slip') }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click="openDialog('meta')"
          v-if="!isWelcome && !isCommentToInbox && $store.getters.getPackage !== 'premium'"
        >
          <v-list-tile-title class="primary-color">{{
            $t('auto_verify_slip_meta')
          }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ['isWelcome', 'isCommentToInbox'],
  data: function() {
    return {
      items: [
        {
          title: this.$t('Address'),
          value: '{address}'
        },
        {
          title: this.$t('AddressAndPhone'),
          value: '{addressandphone}'
        },
        {
          title: this.$t('Phone'),
          value: '{phone}'
        },
        {
          title: this.$t('Email'),
          value: '{email}'
        },
        {
          title: this.$t('Province'),
          value: '{province}'
        },
        {
          title: this.$t('Number'),
          value: '{number}'
        },
        {
          title: this.$t('Date'),
          value: '{date}'
        },
        {
          title: this.$t('image'),
          value: '{image}'
        },
        {
          title: this.$t('sticker'),
          value: '{sticker}'
        },
        {
          title: this.$t('emoji'),
          value: ' {emoji}'
        }
      ]
    }
  },
  mounted() {
    const vm = this
    if (vm.$store.getters.getPackage !== 'premium') {
      vm.items = []
    }
  },
  methods: {
    insertPrefill: function(value) {
      this.$emit('onAddPrefill', value)
    },
    openDialog(type) {
      const vm = this
      vm.$emit('openDailogVerify', type)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentPrefillQuestion.vue